import config from "@/config"
import http from "@/utils/request"
// 整改图片
export default{
    add:{
		url: `${config.API_URL}/rectifiedPhoto/`,
		name: "新增整改图片",
		post: async function(data){
			return await http.post(this.url, data);
		}
	},
    list:{
		url: `${config.API_URL}/rectifiedPhoto/`,
		name: "查询整改图片",
		get: async function(data){
			return await http.get(this.url, data);
		}
	},
	
	

}